<div
  class="source-data-details"
  *ngIf="rowExternalTransactionData.length > 0; else noSourceData"
>
  <nf-table-layout
    [isSectionTitle]="true"
    [gridOptions]="externalTransactionGridOptions"
    [data]="rowExternalTransactionData"
    [autoResizeGrid]="false"
    hideClearAll
    hideTitle
  >
  </nf-table-layout>
</div>
<div>
  <ng-template #noSourceData>
    <hs-panel-card header="No data available"></hs-panel-card>
  </ng-template>
</div>
